(function () {
  document.addEventListener('coupon:variant-change', function (event) {
    event.target.querySelectorAll('[data-product-coupon]').forEach(function (panel) {
      var codes = JSON.parse(panel.getAttribute('data-variant-coupons'));
      var variantId = event.detail.variantId;
      var code = variantId == null ? '' : (codes[String(variantId)] || panel.getAttribute('data-product-coupon-code'));
      var badge = panel.querySelector('[data-coupon-code]');
      clearTimeout(badge.couponResetTimer);
      badge.couponVersion = (badge.couponVersion || 0) + 1;
      badge.removeAttribute('aria-busy');
      badge.setAttribute('data-coupon-code', code);
      var label = badge.getAttribute('data-copy-label') || 'Copy code';
      badge.setAttribute('aria-label', label + ': ' + code);
      badge.querySelector('.coupon-badge__code').textContent = code;
      badge.querySelector('.coupon-badge__status').textContent = label;
      panel.hidden = !code;
    });
  });

  function fallbackCopy(code) {
    var field = document.createElement('textarea');
    var previousFocus = document.activeElement;
    field.value = code;
    field.readOnly = true;
    field.style.position = 'fixed';
    field.style.opacity = '0';
    document.body.appendChild(field);
    field.select();
    field.setSelectionRange(0, code.length);
    try {
      if (!document.execCommand('copy')) throw new Error('Copy failed');
    } finally {
      field.remove();
      if (previousFocus) previousFocus.focus({ preventScroll: true });
    }
  }

  // Delegation includes thumbnails inserted by infinite scroll or theme updates.
  document.addEventListener('click', function (event) {
    var badge = event.target.closest('[data-coupon-code]');
    if (!badge) return;
    event.preventDefault();
    event.stopPropagation();
    if (badge.getAttribute('aria-busy') === 'true') return;

    var code = badge.getAttribute('data-coupon-code');
    if (!code) return;
    var version = badge.couponVersion || 0;
    var status = badge.querySelector('.coupon-badge__status');
    var copyLabel = badge.getAttribute('data-copy-label') || 'Copy code';
    clearTimeout(badge.couponResetTimer);
    badge.setAttribute('aria-busy', 'true');

    var copy = navigator.clipboard && window.isSecureContext
      ? navigator.clipboard.writeText(code).catch(function () { fallbackCopy(code); })
      : Promise.resolve().then(function () { fallbackCopy(code); });

    copy.then(function () {
      if ((badge.couponVersion || 0) !== version) return;
      status.textContent = 'Copied!';
    }).catch(function () {
      if ((badge.couponVersion || 0) !== version) return;
      status.textContent = 'Copy failed — try again';
    }).then(function () {
      if ((badge.couponVersion || 0) !== version) return;
      badge.removeAttribute('aria-busy');
      badge.couponResetTimer = setTimeout(function () {
        status.textContent = copyLabel;
      }, 2500);
    });
  }, true);
}());
